import React from "react";

import QuickForm from "../../utilities/quick-form/quick-form";
import CssInput from "../../utilities/quick-form/custom-inputs/css-input";

import { tailwind } from "../../../models/models";

const ThemeCssModal: React.FC<{ 
  init: string,
  cssObject?: { [key: string]: { [key: string]: string } },
  resolve: (value: { classList: string } | null) => any 
}> = ({init, cssObject, resolve}) => {

  const [classList, setClassList] = React.useState<string>(init);
  const [formErrors, setFormErrors] = React.useState<string[]>([]);

  return (
    <div className="p-2 bg-gradient-to-br from-blue-500 to-pink-500">
      <QuickForm<{ classList: string }> 
        schema={{
          classList: { type: 'string', attributes: { required: true }, meta: { quickForm: {
            CustomInput: CssInput,
            customInputProps: {
              classObject: cssObject || tailwind,
            }
          }}}
        }}
        init={{ classList: classList }}
        onInput={(errors, model) => { (classList !== model.classList) && (() => { setFormErrors(errors); setClassList(model.classList) })() }} 
        labelPlacement={"none"}
      />
      <div className="flex justify-end">
        <button className="btn btn-warning mr-2" onClick={() => resolve(null)}>Cancel</button>
        <button className="btn btn-primary" onClick={() => resolve({ classList: classList })}>Submit</button>
      </div>
    </div>
  );
};

export default ThemeCssModal;